import { Component, OnInit, TemplateRef } from '@angular/core';
import { Report, ReportType } from '../../../models/Report';
import { ReportService } from '../../../services/report.service';
import { AlertService } from '../../../shared/services/alert.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import {BsModalRef} from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ErrorHandlerService } from '../../../services/error-handler.service';

@Component({
  selector: 'app-report-list-config',
  templateUrl: './report-list-config.component.html',
  styleUrls: ['./report-list-config.component.css']
})
export class ReportListConfigComponent implements OnInit {

  reports : Array<Report> = [];
  reportTypes : ReportType[] = [];
  newReport : Report;
  modalRef: BsModalRef;

  constructor(private reportService: ReportService, private modalService: BsModalService,
    private alertService: AlertService,private spinner: NgxSpinnerService, private errorHandlerService: ErrorHandlerService) { }

  ngOnInit() {
    this.reportService.getAllReports().subscribe(resp => {
      this.reports = resp;
    });

    this.reportService.getReportTypes().subscribe(resp => {
      this.reportTypes = resp;
    });
  }

  showCreateReportModal(template: TemplateRef < any >){
    this.newReport = new Report();
    this.modalRef = this.modalService.show(template, {backdrop: 'static', keyboard: false});
  }

  createReport(){
    this.spinner.show();
    this.reportService.createReport(this.newReport).subscribe(
      resp => {
        if(resp){
          this.reportService.getAllReports().subscribe(resp => {
            this.reports = resp;
          });
          this.alertService.success('Report Updated Successfully');
        } else {
          this.alertService.error('Unable to Update Report');
        }
        this.modalRef.hide();
        this.spinner.hide();
      },
      error => {
          let errorMsg = this.errorHandlerService.handleApiError(error);
          this.alertService.error(errorMsg + ' , please try again');
          this.modalRef.hide();
          this.spinner.hide();  
      }
    )
  }

  closeModal(){
    this.modalRef.hide();
  }
}
